import {
  SessionActionsType,
  SET_SESSIONS
} from './actions';
import {
  ISessionInitialState,
  ISessionXpedition,
  ISessionActionHandler
} from './interfaces';

const SessionInitialState: ISessionInitialState = {
  sessions: []
};

const setSessions = ({
  state,
  payload
}: ISessionActionHandler): ISessionInitialState => {
  return {
    ...state,
    sessions: payload as ISessionXpedition[]
  };
};

const sessionReducerHandlers = new Map([
  [SET_SESSIONS, setSessions]
]);

const sessionReducer = (state = SessionInitialState, action: SessionActionsType): ISessionInitialState => {
  const handler = sessionReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<ISessionActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default sessionReducer;
